var _path;
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';
class IconExitFullScreenLine extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  render() {
    return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
      name: "IconExitFullScreen",
      viewBox: "0 0 1920 1920",
      elementRef: this.handleRef
    }), _path || (_path = /*#__PURE__*/React.createElement("path", {
      d: "M876.612 1043.388v710.171H761.27v-513.28L81.663 1920 0 1838.337l679.72-679.606H166.442v-115.343h710.171ZM1838.394 0l81.548 81.548-679.605 679.72h513.28v115.344h-710.172V166.441h115.344v513.164L1838.394 0Z",
      fillRule: "evenodd"
    })));
  }
}
IconExitFullScreenLine.glyphName = 'exit-full-screen';
IconExitFullScreenLine.variant = 'Line';
IconExitFullScreenLine.displayName = 'IconExitFullScreenLine';
// eslint-disable-next-line react/forbid-foreign-prop-types
IconExitFullScreenLine.propTypes = {
  ...SVGIcon.propTypes
};
IconExitFullScreenLine.allowedProps = [...SVGIcon.allowedProps];
export default IconExitFullScreenLine;
export { IconExitFullScreenLine };